import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import Tag from "@/components/base/Tag";
import { guides } from "@/mocks/guides";

export default function GuideTeaser() {
  const list = guides.slice(0, 3);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Verification Guide"
          title="求证方法指南"
          desc="与其等别人给结论，不如掌握一套自己的判断方法。这些指南把核验过程拆成可以照着做的步骤。"
          action={
            <Link
              to="/guide"
              className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-800"
            >
              全部指南
              <i className="ri-arrow-right-line text-base" aria-hidden="true" />
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {list.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-400"
            >
              <Link to={`/guide/${item.slug}`} className="block w-full" aria-label={item.title}>
                <div className="h-40 w-full overflow-hidden bg-background-200 md:h-44">
                  <img
                    src={item.cover}
                    alt={item.coverAlt}
                    title={`${item.title} - 求证指南`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </Link>
              <div className="flex flex-1 flex-col p-5">
                <Tag tone="accent" icon="ri-bookmark-line">
                  {item.category}
                </Tag>
                <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-accent-800">
                  <Link to={`/guide/${item.slug}`}>{item.title}</Link>
                </h3>
                <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {item.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line text-sm" aria-hidden="true" />
                    {item.readTime}
                  </span>
                  <span>{item.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}